import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'
import { useCallback, useMemo } from 'react'
import { Auth, LoginFormData, LoginFormErrors, Me } from '../types'
import { FormikHelpers } from 'formik'
import { MeService } from '../services'
import Cookies from 'js-cookie'
import { useAuth } from '@modules/me/hooks'
import { gettingMeSucceedAction, loggingInSucceedAction } from '../context/actions'

export const useLoginForm = () => {
  const { dispatch } = useAuth()
  const navigate = useBackgroundNavigate()

  const initialValues = useMemo(() => ({ username: '', password: '', rememberMe: true }), [])

  const onSubmit = useCallback(
    async (values: LoginFormData, helpers: FormikHelpers<LoginFormData>) => {
      helpers.setStatus(null)
      const authResult = await MeService.login(values)

      if (authResult.status === 200) {
        const auth = authResult.data as Auth

        const cookieOptions = { expires: values.rememberMe ? 365 : undefined }

        Cookies.set('accessToken', auth.accessToken, cookieOptions)
        Cookies.set('refreshToken', auth.refreshToken, cookieOptions)
        Cookies.set('tokenType', auth.tokenType, cookieOptions)

        dispatch(loggingInSucceedAction(auth))

        const userResult = await MeService.getMe()

        if (userResult.status === 200) {
          dispatch(gettingMeSucceedAction(userResult.data as Me))
          navigate('/')
        } else {
          Cookies.remove('accessToken')
          Cookies.remove('refreshToken')
          Cookies.remove('tokenType')
          helpers.setStatus({ type: 'error', message: userResult.data as string })
        }
      } else if (authResult.status === 422) {
        helpers.setErrors(authResult.data as LoginFormErrors)
      } else {
        helpers.setStatus({ type: 'error', message: authResult.data as string })
      }
    },
    [dispatch, navigate],
  )

  return { onSubmit, initialValues }
}
